import { getToken } from "../lib/auth";
import type { PDDaySummary } from "../types";
import type { PDDaysState } from "./usePDDays";

// Route changes unmount the PD-days list. Its last result is kept in memory
// so returning from a detail screen can show the list immediately while it
// refreshes, and so other screens can look a day up without fetching again.
// Kept apart from usePDDays so reading it does not pull in event tracking.
export interface CachedPDDays {
  token: string;
  endpoint: string;
  state: PDDaysState;
}

let cachedList: CachedPDDays | null = null;

export function readPDDaysCache(): CachedPDDays | null {
  return cachedList;
}

export function writePDDaysCache(next: CachedPDDays | null): void {
  cachedList = next;
}

/** The PD days last fetched in this sign-in, without fetching them again. */
export function cachedPDDays(): PDDaySummary[] {
  return cachedList?.token === (getToken() ?? "") ? cachedList.state.all : [];
}
